//@flow
import {toBlob} from 'html-to-image';
import type {PopupPositionType} from '../../../../../../../entities';

import {
  POPUP_BANNER_CLOSE_ID,
  POPUP_BANNER_CONTENT_ID,
  POPUP_BANNER_EDITOR_ID,
  POPUP_LAYOUT_SIZE,
} from '../constants';

async function getImageBanner(
  editorId: string,
  bannerId: string,
  bannerLayout: PopupPositionType
) {
  const bannerEditor = document.getElementById(editorId);
  if (!bannerEditor) return;

  const bannerContent = bannerEditor.querySelector(`#${bannerId}`);
  const moveableControlBox = bannerEditor.querySelector(
    '.moveable-control-box'
  );
  const closeButton = bannerEditor.querySelector(`#${POPUP_BANNER_CLOSE_ID}`);

  if (bannerContent) bannerContent.style.opacity = '0';
  if (moveableControlBox) moveableControlBox.style.opacity = '0';
  if (closeButton) closeButton.style.opacity = '0';

  const blob = await toBlob(bannerEditor, {
    quality: 1,
    canvasWidth: POPUP_LAYOUT_SIZE[bannerLayout].width,
    canvasHeight: POPUP_LAYOUT_SIZE[bannerLayout].height,
  });

  if (bannerContent) bannerContent.style.opacity = '1';
  if (moveableControlBox) moveableControlBox.style.opacity = '1';
  if (closeButton) closeButton.style.opacity = '1';

  return blob;
}

export async function getPopupBannerBlobImages(
  bannerLayout: PopupPositionType
) {
  const image = await getImageBanner(
    POPUP_BANNER_EDITOR_ID,
    POPUP_BANNER_CONTENT_ID,
    bannerLayout
  );

  return image;
}
